<template>
  <li :class="{'has-error' : hasErrors}" class="d-flex my-3 align-items-center">
    <div class="input-file__filename">{{file.name}}</div>
    <span class="input-file__buttons">
      <span class="input-file__btn btn btn-default d-none" v-if="!file.name">{{$t('input_file_choose')}}</span>
      <input type="file" ref="file" @change="addFile" v-if="!file.name" title="Przeglądaj swój dysk aby wybrać plik, który chcesz dołączyć do zgłoszenia.">
      <a
        href="#"
        class="input-file__btn-remove btn btn-danger py-1 p-2 ms-3 rounded-3"
        @click.prevent="$emit('file:remove', idx)"
        v-if="file.name"
        :title="$t('input_file_remove')"
      ><i class="bi bi-trash"></i><span class="sr-only">{{file.name}}</span></a>
    </span>
    <label v-if="hasErrors">{{activeErrorMessages[0]}}</label>
  </li>
</template>

<script>
import { singleErrorExtractorMixin } from "vuelidate-error-extractor";
export default {
  name: "IcInputFileInput",
  mixins: [singleErrorExtractorMixin],
  props: {
    value: {},
    idx: {}
  },
  data() {
    return {
      file: this.value
    };
  },
  methods: {
    addFile: function() {
      let fileInputs = this.$refs.file;
      this.$emit("file:add", {
        idx: this.idx,
        file: fileInputs.files[0]
      });
    }
  }
};
</script>

<style>
</style>
